import { createAsyncThunk } from '@reduxjs/toolkit';
import { getChecklistCreatorFiles } from '../../api/checklist-creator-files';

export const getChecklistCreatorFilesAsync = createAsyncThunk(
  'getChecklistCreatorFiles/getChecklistCreatorFiles',
  getChecklistCreatorFiles
);
